import { useMemo } from 'react';

import styled from 'styled-components';
import moment from 'moment';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import LTVMainContent from '../../Model/Individual/StatisticsModel/LTVMainContent';

import IntroMarkdown from './IntroMarkdown';

export default function LtvRenderer(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t, isEng } = useLanguage();

  const intro = data?.intro || '';
  const startDate = data?.startDate ? moment(data.startDate) : moment().startOf('month');
  const priceAvg = data?.priceAvg || 0;
  const durationAvg = data?.durationAvg || 0;

  // 통계 화면 기준 응답(회원 목록 대신 그 달 이용 회원 수 members 를 싣는다)이면 그 수를 카드 회원 수로 쓰고, 회원 목록이 오면 목록을 그대로 쓴다 //
  const periodMembers = Array.isArray(data?.durationMembers) ? NaN : Number(data?.members);
  const hasPeriodMembers = Number.isInteger(periodMembers) && periodMembers >= 0;

  // 회원 수 슬라이더가 렌더마다 초기값으로 돌아가지 않도록 같은 배열을 유지한다 //
  const durationMembers = useMemo(() => {
    if (Array.isArray(data?.durationMembers)) return data.durationMembers;
    if (!hasPeriodMembers) return [];

    return Array.from({ length: periodMembers }, (_, idx) => ({ memberId: idx }));
  }, [data?.durationMembers, hasPeriodMembers, periodMembers]);

  let membersLabel;

  if (hasPeriodMembers) {
    const monthLabel = isEng ? startDate.clone().locale('en').format('MMMM') : startDate.month() + 1;

    membersLabel = t('aiManager.ltvPeriodMembers', { month: monthLabel });
  }

  return (
    <TopLevelWrapper>
      <IntroMarkdown text={intro} color={theme.text} />
      <ContentWrapper>
        <LTVMainContent
          priceAvg={priceAvg}
          durationAvg={durationAvg}
          durationMembers={durationMembers}
          startDate={startDate}
          membersLabel={membersLabel} />
      </ContentWrapper>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: calc(100% - 60px);
  padding: 16px 20px;

  gap: 8px;

  border-radius: 12px;
  background-color: ${props => props.theme.subBackground};
`;

